<template>
  <div class="blog-filter">
    <div class="blog-filter__body">
      <component
        :is="componentData.component"
        v-for="(componentData, key) in filter"
        :key="key"
        v-bind="componentData.props || {}"
        :is-mobile="isMobile" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BlogFilterGame from './BlogFilterGame.vue';
import BlogFilterCategory from './BlogFilterCategory.vue';
import BlogFilterSearch from './BlogFilterSearch.vue';
import BlogFilterAnchors from './BlogFilterAnchors.vue';

export default {
  name: 'BlogFilter',

  components: {
    BlogFilterGame,
    BlogFilterCategory,
    BlogFilterSearch,
    BlogFilterAnchors,
  },

  computed: {
    ...mapState(['userDevice']),
    ...mapState('blog', ['filter']),

    isMobile() {
      return this.userDevice.innerWidth < 1280;
    },
  },
};
</script>

<style lang="scss" scoped>
  .blog-filter__body {
    display: grid;
    grid-gap: 16px;
    grid-auto-rows: max-content;
  }
</style>
